"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.NftMetadataProvider = exports.useNftAPI = exports.useNftResource = exports.useNftMetadata = exports.metadataCallBatcher = void 0;
var react_1 = __importStar(require("react"));
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var Ethereum_1 = require("../../api/Ethereum");
var helpers_1 = require("../helpers");
var logic_1 = require("./logic");
var currency = (0, cryptoassets_1.findCryptoCurrencyById)("ethereum");
var ethApi = (0, Ethereum_1.apiForCurrency)(currency);
var NftMetadataContext = (0, react_1.createContext)({
    cache: {},
    loadNFTMetadata: function () { return Promise.resolve(); },
    clearCache: function () { }
});
exports.metadataCallBatcher = (function () {
    var batch = [];
    var debounce;
    var timeoutBatchCall = function () {
        // Clear the previous scheduled call if it was existing
        clearTimeout(debounce);
        // Schedule a new call with the whole batch
        debounce = setTimeout(function () {
            // Seperate each batch element properties into arrays by type and index
            var _a = batch.reduce(function (acc, _a) {
                var couple = _a.couple, resolve = _a.resolve, reject = _a.reject;
                acc.couples.push(couple);
                acc.resolvers.push(resolve);
                acc.rejecters.push(reject);
                return acc;
            }, { couples: [], resolvers: [], rejecters: [] }), couples = _a.couples, resolvers = _a.resolvers, rejecters = _a.rejecters;
            // Empty the batch
            batch.length = 0;
            // Make the call with all the couples of contract and tokenId at once
            ethApi
                .getNFTMetadata(couples)
                .then(function (res) {
                // Resolve each batch element with its own resolver and only its response
                res.forEach(function (metadata, index) { return resolvers[index](metadata); });
            })["catch"](function (err) {
                // Reject all batch element with the error
                rejecters.forEach(function (reject) { return reject(err); });
            });
        });
    };
    return {
        // Load the metadata for a given couple contract + tokenId
        load: function (_a) {
            var contract = _a.contract, tokenId = _a.tokenId;
            return new Promise(function (resolve, reject) {
                batch.push({ couple: { contract: contract, tokenId: tokenId }, resolve: resolve, reject: reject });
                timeoutBatchCall();
            });
        }
    };
})();
// DEPRECATED, use useNftResource
function useNftMetadata(contract, tokenId) {
    var _a = (0, react_1.useContext)(NftMetadataContext), cache = _a.cache, loadNFTMetadata = _a.loadNFTMetadata;
    var key = contract && tokenId ? (0, helpers_1.getNftKey)(contract, tokenId) : "";
    var cachedData = cache[key];
    (0, react_1.useEffect)(function () {
        if (!contract || !tokenId)
            return;
        if (!cachedData || (0, logic_1.isOutdated)(cachedData)) {
            loadNFTMetadata(contract, tokenId);
        }
    }, [contract, tokenId, cachedData, loadNFTMetadata]);
    if (cachedData) {
        return cachedData;
    }
    else {
        return {
            status: "queued"
        };
    }
}
exports.useNftMetadata = useNftMetadata;
function useNftResource(nft) {
    return useNftMetadata(nft === null || nft === void 0 ? void 0 : nft.collection.contract, nft === null || nft === void 0 ? void 0 : nft.tokenId);
}
exports.useNftResource = useNftResource;
function useNftAPI() {
    var _a = (0, react_1.useContext)(NftMetadataContext), clearCache = _a.clearCache, loadNFTMetadata = _a.loadNFTMetadata;
    return {
        clearCache: clearCache,
        loadNFTMetadata: loadNFTMetadata
    };
}
exports.useNftAPI = useNftAPI;
function NftMetadataProvider(_a) {
    var _this = this;
    var children = _a.children;
    var _b = __read((0, react_1.useState)({
        cache: {}
    }), 2), state = _b[0], setState = _b[1];
    var api = (0, react_1.useMemo)(function () { return ({
        loadNFTMetadata: function (contract, tokenId) { return __awaiter(_this, void 0, void 0, function () {
            var key, _a, status_1, result_1, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        key = (0, helpers_1.getNftKey)(contract, tokenId);
                        setState(function (oldState) {
                            var _a;
                            return (__assign(__assign({}, oldState), { cache: __assign(__assign({}, oldState.cache), (_a = {}, _a[key] = {
                                    status: "loading"
                                }, _a)) }));
                        });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, exports.metadataCallBatcher.load({
                                contract: contract,
                                tokenId: tokenId
                            })];
                    case 2:
                        _a = _b.sent(), status_1 = _a.status, result_1 = _a.result;
                        switch (status_1) {
                            case 500:
                                throw new Error("NFT Metadata Provider failed");
                            case 404:
                                setState(function (oldState) {
                                    var _a;
                                    return (__assign(__assign({}, oldState), { cache: __assign(__assign({}, oldState.cache), (_a = {}, _a[key] = {
                                            status: "nodata",
                                            metadata: null,
                                            updatedAt: Date.now()
                                        }, _a)) }));
                                });
                                break;
                            case 200:
                                setState(function (oldState) {
                                    var _a;
                                    return (__assign(__assign({}, oldState), { cache: __assign(__assign({}, oldState.cache), (_a = {}, _a[key] = {
                                            status: "loaded",
                                            metadata: result_1 || {},
                                            updatedAt: Date.now()
                                        }, _a)) }));
                                });
                                break;
                            default:
                                break;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        setState(function (oldState) {
                            var _a;
                            return (__assign(__assign({}, oldState), { cache: __assign(__assign({}, oldState.cache), (_a = {}, _a[key] = {
                                    status: "error",
                                    error: error_1,
                                    updatedAt: Date.now()
                                }, _a)) }));
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); },
        clearCache: function () {
            setState(function (oldState) { return (__assign(__assign({}, oldState), { cache: {} })); });
        }
    }); }, []);
    var value = __assign(__assign({}, state), api);
    return (react_1["default"].createElement(NftMetadataContext.Provider, { value: value }, children));
}
exports.NftMetadataProvider = NftMetadataProvider;
//# sourceMappingURL=index.js.map